import { b2x } from '@b2x/react/src';

export type ServiceContactsSubpageProps = b2x.ServiceContactsSubpageProps;

export const ServiceContactsSubpage = (props: ServiceContactsSubpageProps) => (
  <b2x.ServiceContactsSubpage {...props} contactUs={{ showSatisfiedForm: true }} />
);
